import MapboxDraw from '@mapbox/mapbox-gl-draw';
import * as turf from '@turf/turf';

const SimpleSelectModeOverride = { ...MapboxDraw.modes.simple_select };

SimpleSelectModeOverride.dragMove = function (state, e) {
  MapboxDraw.modes.simple_select.dragMove.call(this, state, e);

  this.getSelected()
    .filter(f => f.properties.isCircle)
    .forEach(feature => {
      const coords = feature.getCoordinates()[0];
      if (coords && coords.length > 0) {
        const newCenter = turf.center(turf.polygon([coords])).geometry.coordinates;
        feature.properties.center = newCenter;
      }
    });
};

SimpleSelectModeOverride.toDisplayFeatures = function (state, geojson, display) {
  if (geojson.properties.user_isCircle &&
      (!geojson.geometry.coordinates.length ||
       !geojson.geometry.coordinates[0].length)) {
    return;
  }
  MapboxDraw.modes.simple_select.toDisplayFeatures.call(this, state, geojson, display);
};

export default SimpleSelectModeOverride;